import { useCountdown, formatTime } from "@/hooks/useCountdown";
import { Timer, AlarmClock } from "lucide-react";

interface CountdownTimerProps {
  targetEpochMs: number | undefined;
}

export default function CountdownTimer({
  targetEpochMs,
}: CountdownTimerProps) {
  const remaining = useCountdown(targetEpochMs);

  if (!targetEpochMs) return null;
  if (remaining <= 0) {
    return (
      <span className="inline-flex items-center gap-1 font-display text-lg font-bold text-error">
        <AlarmClock className="h-5 w-5" />
        Time&apos;s up!
      </span>
    );
  }

  const color =
    remaining > 300
      ? "text-accent"
      : remaining > 60
        ? "text-warning"
        : "text-error";

  return (
    <span className={`inline-flex items-center gap-1.5 font-display text-lg font-bold tabular-nums ${color}`}>
      <Timer className="h-5 w-5" />
      {formatTime(remaining)}
    </span>
  );
}
